// assets
import { ApartmentOutlined, BankOutlined, DatabaseOutlined, VerifiedOutlined } from '@ant-design/icons';

// type
import { NavItemType } from 'types/menu';
import { Rights } from '../graphql/types';

// icons
const icons = {
  ApartmentOutlined,
  DatabaseOutlined,
  BankOutlined,
  VerifiedOutlined
};

// ==============================|| MENU ITEMS - SUPPORT ||============================== //

const organizations: NavItemType = {
  id: 'organizations',
  title: 'Organizations',
  type: 'group',
  rights: [Rights.ListUnderwriters, Rights.ListMerchantCompanies],
  children: [
    {
      id: 'merchants-list',
      title: 'Merchants',
      type: 'item',
      url: '/merchants/list',
      icon: { anticon: icons.DatabaseOutlined }
    },
    {
      id: 'lenders-list',
      title: 'Underwriters',
      type: 'item',
      url: '/underwriters/list',
      icon: { anticon: icons.VerifiedOutlined }
    },
    {
      id: 'funding-companies-list',
      title: 'Funding Companies',
      type: 'item',
      url: '/funding-companies/list',
      icon: { anticon: icons.ApartmentOutlined }
    },
    {
      id: 'banks-list',
      title: 'Banks',
      type: 'item',
      url: '/banks/list',
      icon: { anticon: icons.BankOutlined },
      rights: [Rights.IsSuperAdmin]
    }
  ]
};

export default organizations;
